import { BuildCircle, Login } from "@mui/icons-material";
import {
  Stack,
  Button,
  Dialog,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { noop } from "lodash/fp";
import { useCallback, useState, SyntheticEvent } from "react";

type Props = {
  formLabel: string;
  isOpen: boolean;
  onLoginValidation: (eventCode: string) => boolean;
};

const RestarterEventLoginModal = ({
  formLabel,
  isOpen,
  onLoginValidation,
}: Props) => {
  const [eventCode, setEventCode] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(true);

  const handleLoginSubmit = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();
      const isValid = onLoginValidation(eventCode);

      setIsCodeValid(isValid);
    },
    [onLoginValidation, eventCode]
  );

  return (
    <Dialog fullScreen open={isOpen} onClose={noop}>
      <Stack height="100%" justifyContent="space-around">
        <Stack
          component="form"
          onSubmit={handleLoginSubmit}
          alignItems="center"
          gap={4}
        >
          <Typography variant="h5">{formLabel}</Typography>
          <TextField
            required
            error={!isCodeValid}
            helperText={!isCodeValid && "Invalid Event Code"}
            label="Enter Event Code"
            value={eventCode}
            onChange={(e) => setEventCode(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BuildCircle />
                </InputAdornment>
              ),
            }}
          />
          <Button endIcon={<Login />} type="submit" variant="contained">
            Login
          </Button>
        </Stack>
        <div />
      </Stack>
    </Dialog>
  );
};

export default RestarterEventLoginModal;
